/**
 * Splice `emoji` into `value` at the textarea's current selection, replacing
 * any selected range. Returns the next value plus the caret offset that should
 * be restored once React has committed that value — callers must not call
 * setSelectionRange synchronously, or the re-render clobbers it and the caret
 * snaps to the end. Pair with useCaretRestore. Falls back to appending when
 * there is no live element.
 */
export function insertEmojiAtCursor(
  el: HTMLTextAreaElement | null,
  value: string,
  emoji: string,
): { next: string; caret: number } {
  const start = el?.selectionStart ?? value.length;
  const end = el?.selectionEnd ?? value.length;
  const next = value.slice(0, start) + emoji + value.slice(end);
  return { next, caret: start + emoji.length };
}
